import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReduxState } from 'types/reducers'
import { useTheme } from '@material-ui/core'

interface Props {
  open: boolean
  title: string
  subtitle?: string
  width?: number
  handleClose?: () => void
  headerActions?: React.ReactNode
}

const GenericDrawer: React.FC<Props> = ({ open, title, subtitle, children, width, handleClose, headerActions }) => {
  const drawerWidth = width || 480
  const theme = useTheme()
  const isDarkMode = theme.palette.type === 'dark'

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => handleClose && handleClose()}
      PaperProps={{
        style: {
          width: drawerWidth,
          maxWidth: '100vw',
          display: 'flex',
          flexDirection: 'column',
          background: isDarkMode ? '#1e293b' : '#FFFFFF',
          borderLeft: isDarkMode ? '1px solid #334155' : '1px solid #e2e8f0',
        },
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          borderBottom: isDarkMode ? '1px solid #334155' : '1px solid #e2e8f0',
          flexShrink: 0,
          background: isDarkMode ? '#1e293b' : '#FFFFFF',
        }}
      >
        <div>
          <span
            style={{
              fontFamily: 'Public Sans, sans-serif',
              fontWeight: 600,
              fontSize: 18,
              color: isDarkMode ? '#e4e7ec' : '#202939',
              display: 'block',
            }}
          >
            {title}
          </span>
          {subtitle && (
            <span
              style={{
                fontFamily: 'Public Sans, sans-serif',
                fontWeight: 400,
                fontSize: 13,
                color: isDarkMode ? '#cbd5e1' : '#667085',
                display: 'block',
                marginTop: 2,
              }}
            >
              {subtitle}
            </span>
          )}
        </div>
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          {headerActions}
          {handleClose && (
            <IconButton size="small" onClick={() => handleClose()} aria-label="close">
              <CloseIcon fontSize="small" style={{ color: isDarkMode ? '#cbd5e1' : '#6B7280' }} />
            </IconButton>
          )}
        </div>
      </div>

      {/* Body */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '20px 24px',
          background: isDarkMode ? '#1e293b' : '#FFFFFF',
        }}
      >
        {children}
      </div>
    </Drawer>
  )
}

export default GenericDrawer
